module.exports = __webpack_public_path__ + "img/Step1-m.dbfa220.svg";